import { useMemo } from 'react'

import { ModalContext } from '@domain-group/suit-theme'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'

import PageContext from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import CreateBrandGroupModal from '@modals/CreateBrandGroupModal'

import { BrandGroupModel } from '@models/brandGroup'

import PageContent from './components/PageContent'

const callbacks = (component: keyof typeof componentCallbacks, setState: Function) => {
  const componentCallbacks = {
    CreateBrandGroupModal: {
      closeModal: () => setState({ showCreateBrandGroupModal: false }),
      createBrandGroup: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const defaultState = {
  showCreateBrandGroupModal: false,
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const { showCreateBrandGroupModal } = state

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    pageFilters,
  } = useFilters()

  const modalContext = useModals({ setState })
  const {
    callbacks: { setModalData },
  } = modalContext

  const pageContext = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      showCreateBrandGroupModal: (payload: { brandGroup: Partial<BrandGroupModel> }) => {
        setModalData('CreateBrandGroupModal', payload)
        setState({ showCreateBrandGroupModal: true })
      },
    },
    defaultFilters,
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent pageFilters={pageFilters} />

        <CreateBrandGroupModal
          callbacks={callbacks('CreateBrandGroupModal', setState)}
          showModal={showCreateBrandGroupModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
